export default "__VITE_ASSET__UIWmBsjn__"